import { cn } from '@costar-ui/cosmos';
import React from 'react';
import { starSvgIcon } from './star-svg-icon.esm.js';
import { usePropId } from '../../../utils/use-prop-id.esm.js';

var SingleRatingStar = function SingleRatingStar(props) {
  var inactiveColor = props.inactiveColor,
    value = props.value,
    disabled = props.disabled,
    onClick = props.onClick,
    classNames = props.classNames;
  var id = usePropId();
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: starSvgIcon.viewBox,
    className: cn([onClick && !disabled ? 'cursor-pointer' : '', disabled ? 'cursor-not-allowed' : '', classNames]),
    onClick: onClick,
    role: onClick ? 'button' : 'img',
    stroke: "currentcolor",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement(starSvgIcon.element, {
    id: id,
    fill: value,
    secondaryColor: inactiveColor,
    disabled: disabled
  }));
};

export { SingleRatingStar };
//# sourceMappingURL=single-rating-star.esm.js.map
